import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from '@ui/shared/feature-config';
import type { FoundingMapItemModel } from './app/entities/founding-map-item.model';
import type { FoundingMapFilter } from './app/types/founding-map-filters';
import { FoundingMapMapDataService } from './app/services/founding-map-map-data.service';
import { SearchFilterConfigService } from './app/services/filter/search-filter-config.service';
import { TypeSelectFilterConfigService } from './app/services/filter/type-select-filter-config.service';
import { SectorSelectFilterConfigService } from './app/services/filter/sector-select-filter-config.service';
import { FoundingContactPointMapDataService } from './app/services/data/founding-contact-point-map-data.service';
import { FoundingRoomMapDataService } from './app/services/data/founding-room-map-data.service';
import { FoundingNewFoundingMapDataService } from './app/services/data/founding-new-founding-map-data.service';

bootstrapApplication(AppComponent, createAppConfig<FoundingMapItemModel, FoundingMapFilter>({
    mapDataStateService: FoundingMapMapDataService,
    filterItems: [
        SearchFilterConfigService,
        TypeSelectFilterConfigService,
        SectorSelectFilterConfigService,
        // TargetGroupSelectFilterConfigService,
    ],
    dataEndpoints: [
        FoundingContactPointMapDataService,
        FoundingRoomMapDataService,
        FoundingNewFoundingMapDataService,
    ],
})).catch((err: unknown) => console.error(err));
